import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteRecordRaw,
} from "vue-router";
import HomePage from "../views/home/Home.vue";
import ProjectsPage from "../views/projects/projects.page.vue";
import WorkPage from "../views/work/work.page.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/work",
    name: "work",
    component: WorkPage,
  },
  {
    path: "/projects",
    name: "projects",
    component: ProjectsPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from): void {
    if (to.fullPath.includes("#")) return;
    const c: HTMLElement = document.getElementById("app") as HTMLElement;
    c.scrollIntoView({
      behavior: "smooth",
    });
  },
});

export default router;
